module.exports = __webpack_public_path__ + "img/arrow-down.4129f1b1.png";